// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".my[data-v-2617cb52]{background-color:#f6faf9}.my .border-box[data-v-2617cb52]{margin-bottom:.266667rem;background:#fff}.my .list[data-v-2617cb52]{display:flex;justify-content:space-between;align-items:center;margin-bottom:.266667rem}.my .list-count[data-v-2617cb52]{color:#1677ff}.my .list .van-cell[data-v-2617cb52]{border:.026667rem solid #000;border-radius:.133333rem;width:70%;padding:.186667rem .426667rem}", ""]);
// Exports
module.exports = exports;
